import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Home from './views/Home.vue';
import About from './views/About.vue';

Vue.use(Router);

function importAll(context: any) {
  context.keys().forEach((key: string) => {
    routes = [...routes, ...context(key).routes];
  });
}

let routes: RouteConfig[] = [];

importAll(require.context('./routers', false, /\.ts$/));

const router = new Router({
  base: '/m/',
  routes,
});

export { router };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/router.ts